import { Typography } from '@mui/material';
import React from 'react';
import { ErrorReference, GraphQlRequestErrorCode } from '../../../../api/types';
import { Error } from './Error';
import ErrorTechnicalDetails from './ErrorTechnicalDetails';

interface WrongAuthMethodErrorProps {
  errorCode: GraphQlRequestErrorCode;
  errorReference: ErrorReference | null;
}

const WrongAuthMethodErrorComponent = (props: WrongAuthMethodErrorProps) => {
  const { errorCode, errorReference } = props;

  return (
    <Error
      title={{ key: 'pages:errorBoundary.wrongAuthMethodError' }}
      message={(t) => (
        <>
          <Typography variant="h5">
            {t('pages:errorBoundary.contactAdministrator')}
          </Typography>
          <ErrorTechnicalDetails
            errorCode={errorCode}
            errorReference={errorReference}
          />
        </>
      )}
    />
  );
};

export default WrongAuthMethodErrorComponent;
